import { render, staticRenderFns } from "./DocumentUsersLog.vue?vue&type=template&id=23d031a2"
import script from "./DocumentUsersLog.vue?vue&type=script&lang=js"
export * from "./DocumentUsersLog.vue?vue&type=script&lang=js"
import style0 from "./DocumentUsersLog.vue?vue&type=style&index=0&id=23d031a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports